import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Typography, useTheme } from "@mui/material";
import { AuthFlowLayout, STORAGE_DEVICE_ID_KEY, } from "@pangeacyber/react-mui-authn";
var FlowCompleteView = function (_a) {
    var options = _a.options, data = _a.data;
    var _b = useState(), deviceId = _b[0], setDeviceId = _b[1];
    var formRef = useRef(null);
    var theme = useTheme();
    useEffect(function () {
        // if a device_id is set in sessionStorage, send it as a device_id
        // and save it in local storage
        var storedId = sessionStorage.getItem(STORAGE_DEVICE_ID_KEY) || "";
        if (storedId) {
            sessionStorage.removeItem(STORAGE_DEVICE_ID_KEY);
            localStorage.setItem(STORAGE_DEVICE_ID_KEY, storedId);
        }
        setDeviceId(storedId);
    }, []);
    useEffect(function () {
        if (formRef.current && deviceId !== undefined) {
            formRef.current.submit();
        }
    }, [deviceId]);
    var content = options.brandName ? " to ".concat(options.brandName) : "";
    return (_jsxs(AuthFlowLayout, { title: "Authentication Successful", children: [_jsxs(Typography, { variant: "body2", sx: { color: theme.palette.text.secondary }, children: ["Redirecting", content] }), _jsxs("form", { ref: formRef, action: "/component/complete", method: "POST", children: [_jsx("input", { type: "hidden", name: "flow_id", value: data.flowId }), deviceId && _jsx("input", { type: "hidden", name: "device_id", value: deviceId })] })] }));
};
export default FlowCompleteView;
